var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer rotatable hover:text-gray-500",class:{ rotated: _vm.showChildren },on:{"click":function($event){$event.preventDefault();_vm.showChildren = !_vm.showChildren}}},[_c('IconChevron')],1)}
var staticRenderFns = []

export { render, staticRenderFns }